import { Utils } from "@/plugins/utils"

function flattenFn1(viewModel) {
	return viewModel ? { ...viewModel.fn1, cf1nome: viewModel.cf1nome } : null
}

export default {
	namespaced: true,
	state: {
		lstFn1: [],
		fn1: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getFn1: state => state.fn1,
		getLstFn1: state => state.lstFn1,
		getInsert: state => state.insert,
		getUpdate: state => state.update,
		getLoading: state => state.loading,
		getItemsPerPage: state => state.itemsPerPage,
		getSearch: state => state.search,
		getHasNext: state => state.hasNext,
	},
	mutations: {
		initForm(state) {
			state.insert = false
			state.update = false
			state.fn1 = null
		},
		setFn1(state, fn1) {
			state.fn1 = fn1
			if (fn1) state.update = true
		},
		setLstFn1(state, lstFn1) {
			state.lstFn1 = lstFn1
		},
		setLoading(state, loading) {
			state.loading = loading
		},
		setInsert(state, insert) {
			state.insert = insert
		},
		setSearch(state, search) {
			state.search = search
		},
		setParamsDataTable(state, payload) {
			state.lstFn1 = (payload.items || []).map(flattenFn1)
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm({ commit }) {
			commit("initForm")
		},
		async find({ commit, dispatch }, fn1agente) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/FinancialAgent/Find/${fn1agente}`)
				.then(response => {
					let fn1 = flattenFn1(Utils.ValidateAxiosResponse(response.data))
					commit("setFn1", fn1)
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		save({ dispatch, getters }) {
			if (getters.getUpdate) {
				return dispatch("update")
			}
			return dispatch("insert")
		},
		async insert({ dispatch, commit, getters }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.post("/Financial/FinancialAgent/Insert", getters.getFn1)
				.then(response => {
					let fn1 = flattenFn1(Utils.ValidateAxiosResponse(response.data))
					commit("setInsert", false)
					commit("setFn1", fn1)
					return fn1
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async update({ dispatch, commit, getters }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.put("/Financial/FinancialAgent/Update", getters.getFn1)
				.then(response => {
					let fn1 = flattenFn1(Utils.ValidateAxiosResponse(response.data))
					commit("setFn1", fn1)
					return fn1
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return null
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async delete({ dispatch, getters }) {
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
			let payload = await this._vm.$axios
				.delete(`/Financial/FinancialAgent/Delete/${getters.getFn1.fn1agente}`)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data)
				})
				.catch(error => {
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			return payload
		},
		async search({ commit, dispatch, getters }, { limit = 20, page = 1 }) {
			commit("setLoading", true)
			commit("initForm")
			await this._vm.$axios
				.get(`/Financial/FinancialAgent/Search?search=${getters.getSearch}&limit=${limit}&page=${page}`)
				.then(response => {
					let payload = Utils.ValidateAxiosResponse(response.data)
					commit("setParamsDataTable", payload)
				})
				.catch(error => {
					commit("setLstFn1", [])
					commit("setSearch", "")
					dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					}, { root: true })
				})
			commit("setLoading", false)
		},
		setSearch({ commit }, search) {
			commit("setSearch", search)
		},
		setInsert({ commit }, insert) {
			commit("setInsert", insert)
		},
		setFn1({ commit }, fn1) {
			commit("setFn1", fn1)
		},
	},
}
